import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { ReactElement, forwardRef } from "react";
import { COLORS } from "@/constants";

type AppButtonProps = ButtonProps & {
  loading?: boolean;
};

export const AppButton = forwardRef<HTMLButtonElement, AppButtonProps>(
  ({ sx, variant = "contained", loading = false, disabled, children, ...props }, ref): ReactElement => {
    const defaultSx =
      variant === "contained"
        ? {
            background: COLORS.button.primaryBackground,
            color: COLORS.button.primaryColor,
            "&:hover": {
              background: COLORS.button.primaryHoverBackground,
              color: COLORS.button.primaryHoverColor,
            },
            "&.Mui-disabled": {
              background: COLORS.button.disabledBackground,
              backgroundColor: COLORS.button.disabledBackground,
              color: COLORS.button.disabledColor,
              fontWeight: 500,
              fontSize: "14px",
            },
          }
        : {};

    let sxArray: any[] = [];
    if (sx) {
      sxArray = Array.isArray(sx) ? sx : [sx];
    }
    const mergedSx = [defaultSx, ...sxArray];

    return (
      <Button
        ref={ref}
        variant={variant}
        sx={mergedSx}
        disabled={disabled || loading}
        {...props}
      >
        {loading && (
          <CircularProgress size={16} sx={{ color: "inherit", mr: 1 }} />
        )}
        {children}
      </Button>
    );
  },
);

AppButton.displayName = "AppButton";
